/* COMPONENT IMPORTS*/
import ProductDetails from "../../components/ProductDetails/ProductDetails";
import ContextConstructor from "../../components/Context/Context";
import sendLogError from "../../sendLogError";

/* MODULE IMPORTS */
import { withRouter } from "react-router";
import React, { Component } from "react";
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    DotGroup,
} from "pure-react-carousel";

/* SAME FOLDER IMPORTS*/

/* CSS IMPORT */
import "./tablestyling.css";
import "pure-react-carousel/dist/react-carousel.es.css";
import SavingsPlan from "../../components/SavingsPlan/SavingsPlan";
import AddSubscription from "../../components/Subscription/AddSubscription";
import newseriesImg from "../../images/newseries.png";

class SavingNewItemsMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            actualDateAVOA: null,
            startDateAVOA: null,
            endDateAVOA: null,
            flagAVOA: false,
            showSavingsPlan: false,
            selectedParams: null,
            selectedModalidade: null,
            showAddSubscription: false,
        };
    }

    componentDidMount() {
        this.getAVOApopup();
    }

    createSubscription(item) {
        var data = {
            subscriptionID: null,
            subscriptionSerieID: null,
            canReapply: false,
            canReinforce: false,
            actualDateAVOA: null,
            startDateAVOA: null,
            endDateAVOA: null,
            flagAVOA: false,
        };
        this.setState({
            selectedParams: data,
            selectedModalidade: item,
            selectedProductName: item?.productName || '',
            showAddSubscription: true
        });
    }

    openDetalhesPopup(index) {
        document.getElementById("popupDetalhesTrigger" + index).click();
    }

    render() {
        let itemsToRender = this.props.savingsNewList.filter((item) => item.subscriptionsNumber == 0);
        let numItems = itemsToRender.length;
        const { showAddSubscription, selectedParams, selectedModalidade } = this.state;

        if (showAddSubscription && selectedParams && selectedModalidade) {
            return (
                <AddSubscription
                    params={selectedParams}
                    modalidade={selectedModalidade}
                    productName={this.state.selectedProductName}
                    onClose={() => this.setState({ showAddSubscription: false })}
                />
            );
        }
        return (
            <React.Fragment>
                <div className="carousel-wrapper carousel-subscricao-nova-modalidade">
                    <div className="consulta-detalhes-clicaveis-poupanca">
                        {itemsToRender.map((item, index) => (
                            <ProductDetails
                                key={index}
                                elementID={"popupDetalhesTrigger" + index}
                                productID={item.productID}
                                subscriptionType="product"
                                productName={item.productName}
                                subscriptionActive={false}
                            />
                        ))}
                    </div>
                    <CarouselProvider
                        naturalSlideWidth={400}
                        naturalSlideHeight={500}
                        totalSlides={numItems}
                        visibleSlides={1}>
                        <Slider>
                            {itemsToRender.map((item, index) => (
                                <Slide key={index} index={index}>
                                    <div key={index} className="card-new card-new-mobile">
                                        <div className="card-new-table">
                                            <div className="card-new-title">
                                                <div
                                                    className="serie-name-wrapper"
                                                    style={{ position: "initial !important" }}>
                                                    <div
                                                        onClick={this.openDetalhesPopup.bind(this, index)}
                                                        className="tableCapitalCerto-title-inactive">
                                                        {item.productName}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tableCapitalCerto-amount">
                                                <div className="card-new-table-value">0 €</div>
                                                <div className="tableCapitalCerto-subtitle-unactive">Montante aplicado</div>
                                            </div>
                                            <div className="tableCapitalCerto-amount">
                                                <div className="tableCapitalCerto-boldvalue">-</div>
                                                <div className="tableCapitalCerto-subtitle-unactive">
                                                    Rendimento Bruto
                                                </div>
                                            </div>
                                            <div
                                                id="saving-create-subscription-button"
                                                onClick={this.createSubscription.bind(this, item)}>        
                                                <img src={newseriesImg}></img>
                                                <div className="createSubscriptionMobile-text">Subscrever</div>
                                            </div>
                                        </div>
                                    </div>
                                </Slide>
                            ))}
                        </Slider>
                        <DotGroup />
                    </CarouselProvider>
                </div>
            </React.Fragment>
        );
    }

    async getAVOApopup() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Elections/GetAVOADates", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            this.setState({
                actualDateAVOA: data?.actualDateAVOA || null,
                startDateAVOA: data?.startDateAVOA || null,
                endDateAVOA: data?.endDateAVOA || null,
                flagAVOA: data?.flagAVOA ?? false,
            });

        } catch (error) {
            console.error("Error fetching AVOA popup:", error);

            sendLogError(error.message, "getAVOApopup");
        }
    }
}

SavingNewItemsMobile.contextType = ContextConstructor;

export default withRouter(SavingNewItemsMobile);
